import { Assets, AnimatedSprite, Texture } from "pixi.js"
import { applyVelocity } from "../lib/apply-velocity"
import { mod } from "../lib/mod"
import { shortestAngle } from "../lib/shortest-angle"
import { applyFriction } from "../lib/apply-friction"
import { Pathing } from "./pathing"
import { followPath } from "../lib/follow-path"
import { useVulnerability } from "./use-vulnerability"
import { useAttackPlayer } from "./use-attack-player"

const FRAMES = 2
const FRICTION = 0.03

export async function Snake({ player, isSolid, x, y }) {
  await Assets.load("res/snake.json")
  const frames = [...Array(FRAMES)].map((_, i) =>
    Texture.from(`snake ${i}.ase`),
  )

  const sprite = new AnimatedSprite(frames)
  sprite.anchor.set(0.8, 0.5)
  sprite.x = x ?? 0
  sprite.y = y ?? 0
  sprite.velocity = { x: 0, y: 0 }
  sprite.animationSpeed = 0.1
  sprite.play()

  const { path, tick: tickPathing } = Pathing({
    subject: sprite,
    target: player,
    isSolid,
    radius: 500,
  })

  useVulnerability(sprite, {
    player,
    health: 1,
    radius: 8,
    points: [
      { x: -0.65, y: 0 },
      { x: -0.4, y: 0 },
      { x: -0.15, y: 0 },
      { x: 0.1, y: 0 },
    ],
  })

  const attack = useAttackPlayer(sprite, {
    player,
    damage: 2,
    attackRadius: 4,
  })

  sprite.tick = (time) => {
    if (Date.now() - sprite.lastAttack >= sprite.attackCooldown)
      followPath({ subject: sprite, path, speed: 0.1, target: player }, time)

    applyVelocity(sprite, { isSolid, time })
    applyFriction(sprite, { time, friction: FRICTION })

    const angle = Math.atan2(sprite.velocity.y, sprite.velocity.x)
    sprite.rotation +=
      shortestAngle(
        mod(angle, 2 * Math.PI),
        mod(sprite.rotation, 2 * Math.PI),
      ) *
      0.05 *
      time.deltaTime

    tickPathing(time)

    attack()

    if (sprite.lastHit && Date.now() - sprite.lastHit < 500) sprite.alpha = 0.5
    else sprite.alpha = 1
  }

  return sprite
}
